import AppelsList  from "../../components/Appels/AppelsList";
function AppelsListPage(){
  return (
  <div>
    <AppelsList   />
  </div>
  );
}
export default AppelsListPage;